export default __webpack_public_path__ + "static/media/nature.4986ef22.jpeg";